<template>
  <div>
    <div class="tile is-parent">
      <article class="tile is-child box detail-page-tile">
        <h1 class="title has-text-centered"
          v-if="!isValidImageHyperlink">The link has expired</h1>
        <div v-if="isValidImageHyperlink">
          <table class="table table-transparent">
            <tbody v-if="quote && vehicle">
              <tr>
                <td class="has-text-weight-bold">Quote No.</td>
                <td>{{ quote.quoteNo }}</td>
              </tr>
              <tr>
                <td class="has-text-weight-bold">Registration No.</td>
                <td>{{ vehicle.rego }}</td>
              </tr>
              <tr>
                <td class="has-text-weight-bold">Make / Model</td>
                <td>{{ `${vehicle.model.make} ${vehicle.model.model}` }}</td>
              </tr>
            </tbody>
          </table>
          <div class="is-divider" />
          <count-down-timer class="has-text-right mb-3"
            :target-date-time="zonedExpiredDate"
            @count-down-timeout="countDownTimeout"
          ></count-down-timer>
          <div class="buttons is-right">
            <a class="button is-primary"
              @click="dropzoneRemoveAllFiles"
              :disabled="isUploading || !validQuote">
              <span class="icon">
                <i class="mdi mdi-close mdi-18px" />
              </span>
              <span>Clear</span>
            </a>
            <a class="button is-success"
              @click="upload"
              :disabled="isUploading || !validQuote">
              <span class="icon">
                <i class="mdi mdi-upload mdi-18px" />
              </span>
              <span>Upload</span>
            </a>
          </div>
          <div class="field"
            v-show="isDropzoneActive && isMobile()"
          >
            <label class="label">Select Image Source</label>
            <div class="control">
              <div class="select">
                <select v-model="dropzoneOptions.capture">
                  <option :value="mobileImageSourceType.Gallery">From Gallery</option>
                  <option :value="mobileImageSourceType.Camera">From Camera</option>
                </select>
              </div>
            </div>
          </div>
          <!-- <div class="field"
            v-show="isDropzoneActive">
            <label class="label">Select Image Category</label>
            <div class="select">
              <select v-model="selectedCategoryId"
                :disabled="selectedCategoryId"
                @change="clearUploadedFile">
                <option v-for="cat in imageCategories"
                  :key="cat.quoteImageCategoryId"
                  :value="cat.quoteImageCategoryId">
                  {{ cat.name }}
                </option>
              </select>
            </div>
          </div> -->
          <vue-dropzone v-if="validQuote && isDropzoneActive"
            ref="quoteImageDropzone"
            id="dropzone"
            :options="dropzoneOptions"
            @vdropzone-mounted="dropzoneMounted"
            @vdropzone-file-added="dropzoneFileAdded"
            @vdropzone-success="dropzoneSuccess"
            @vdropzone-success-multiple="dropzoneSuccessMultiple"
            @vdropzone-error-multiple="dropzoneErrorMultiple"
            @vdropzone-error="dropzoneError"
            @vdropzone-sending="dropzoneSending"
            @vdropzone-total-upload-progress="dropzoneTotalUploadProgress"
            @vdropzone-complete-multiple="dropzoneCompleteMultiple"
            @vdropzone-queue-complete="dropzoneQueueComplete"
            @vdropzone-removedfile="onFileRemoved"
          />
          <div>
            <mobile-image-viewer v-if="imagesWithInfo"
              :images-with-info="imagesWithInfo"
              @update-image="getImageIds" />
          </div>
        </div>
        <div class="modal animated pulse"
          :class="{ 'is-active': isShowPopUp }">
          <div class="modal-background"></div>
          <div class="modal-card">
            <header class="modal-card-head">
              <p class="modal-card-title is-flex-items-center">
                <span class="icon is-medium has-text-warning"
                  style="margin-right: 0.5rem">
                  <i class="mdi mdi-36px mdi-alert-decagram" />
                </span>
                Message
              </p>
              <button class="delete"
                aria-label="close"
                @click="closePopUp"></button>
            </header>
            <section class="modal-card-body">
              <h3>{{ popUpMessage }}</h3>
            </section>
          </div>

        </div>
      </article>
    </div>
  </div>
</template>

<script>
import mimeTypes from 'mime-types'
import VueDropzone from '@/components/VueDropzone'
import { FocusInserted } from '@/components/directives'
import MobileImageUploaderService from '../mobileimageuploader/MobileImageUploaderService'
import { guidValidator } from '@/components/validators'
import Guid from '@/components/Guid'
// import _debounce from 'lodash.debounce'
import { MobileImageSourceType } from '@/enums'
import platform from 'platform'
import common from '../../common'
import CountDownTimer from '@/components/CountDownTimer/CountDownTimer'
import { DateTime } from 'luxon'
import MobileImageViewer from './MobileImageViewer.vue'

export default {
  name: 'MobileImageUploader',
  directives: {
    FocusInserted
  },
  components: {
    VueDropzone,
    CountDownTimer,
    MobileImageViewer
  },
  props: {},
  data() {
    return {
      quoteId: '',
      isDropzoneActive: false,
      isClearAllActive: false,
      isUploading: false,
      queuedFileCount: 0,
      successFileCount: 0,
      failedFileCount: 0,
      dropzoneOptions: {
        url: `${process.env.VUE_APP_WEBAPI_URI}/quotes/mobileimages/upload/${this.quoteId}/${this.mainQuoteNo}/${this.subQuoteNo}/${this.selectedCategoryId}/${this.companyId}`,
        dictDefaultMessage: 'Drop files here or click to upload',
        autoProcessQueue: false,
        thumbnailWidth: 200,
        thumbnailHeight: 200,
        maxFilesize: 10,
        resizeWidth: 1920,
        resizeHeight: 1920,
        acceptedFiles: 'image/jpeg,image/png',
        capture: 'image/',
        addRemoveLinks: true,
        headers: {
          Authorization: ''
        },
        maxFiles:25,
        parallelUploads: 1,
        accept: function (file, done) {
          const mimeType = file.type
          if (mimeType !== mimeTypes.contentType('jpeg')) {
            this.options.resizeMimeType = mimeTypes.contentType('jpeg')
            this.options.resizeQuality = 0.95
            done()
            return
          }
          done()
        },
        renameFile(file) {
          const extension = file.name.split('.').pop()
          if (extension !== 'jpg' || extension !== 'jpeg') {
            return `${file.name.substr(0, file.name.lastIndexOf('.'))}.${mimeTypes.extension(
              mimeTypes.contentType('jpeg')
            )}`
            // return file.name.substr(0, file.name.lastIndexOf('.')) + '.jpg'
          } else {
            return file.name
          }
        }
      },
      imageCategories: null,
      selectedCategoryId: '',
      quoteImageHyperlinkId: this.$route.params.id || '',
      companyId:'',
      quote:null,
      vehicle: null,
      isValidImageHyperlink : false,

      minWidth: 640,
      minHeight: 480,

      popUpMessage: '',
      isShowPopUp: false,
      zonedExpiredDate: null,
      imagesWithInfo: [],
      size: 200,

      timeoutId: null
    }
  },
  validations: {
    quoteId: {
      validGuid: guidValidator
    }
  },
  computed: {
    validQuote() {
      return this.$v.quoteId && !this.$v.quoteId.$error
    },
    mainQuoteNo() {
      if(this.quote){
        return this.quote.quoteNo
      }
      return ''
    },
    subQuoteNo() {
      if(this.quote){
        return this.quote.subQuoteNo
      }
      return '0'
    },
    mobileImageSourceType() {
      return MobileImageSourceType
    }
  },
  watch: {
    'dropzoneOptions.capture': function (newVal, oldVal) {
      // Reload vue-dropzone component here
      if (this.isDropzoneActive === true) {
        this.isDropzoneActive = false
        this.$nextTick(() => {
          this.isDropzoneActive = this.validQuote
        })
      }
    }
  },
  async created() {
    if(this.$route.params.id){
      await this.checkImageHyperlink()
      await this.checkLinkStillActive()
    }
    // if(this.quoteImageHyperlinkId){
    //   this.getQuote()
    // }
    // this.dropzoneOptions.capture = this.isMobile
    //   ? this.mobileImageSourceType.Gallery
    //   : this.mobileImageSourceType.Camera
    // document.title = this.$route.meta.title
  },
  mounted() {
  },
  beforeDestroy() {
    this.clearTimeout()
  },
  methods: {
    upload() {
      if (this.$refs.quoteImageDropzone.getAcceptedFiles().length > 0) {
        this.queuedFileCount = this.$refs.quoteImageDropzone.getQueuedFiles().length
        this.$refs.quoteImageDropzone.processQueue()
      }
    },
    dropzoneMounted() {
      // console.log(this.$refs.quoteImageDropzone.getAcceptedFiles())
    },
    async dropzoneFileAdded(file) {
      const resolution = await common.getImageResolution(file)
      if (resolution) {
        const isAcceptable = resolution.width >= this.minWidth && resolution.height >= this.minHeight
        if (!isAcceptable) {
          this.$refs.quoteImageDropzone.removeFile(file)
          this.popUpMessage = 'Please provide image resolution 480p (640x480) width x height or above.'
          this.isShowPopUp = true
          return
        }

         this.$refs.quoteImageDropzone.changeUrl(
            `${process.env.VUE_APP_WEBAPI_URI}/quotes/mobileimages/upload/${this.quoteId}/${this.mainQuoteNo}/${this.subQuoteNo}/${this.selectedCategoryId}/${this.companyId}`
         )
         this.isClearAllActive = true
      }
      // this.isUploading = true
    },
    dropzoneSuccessMultiple(files, response) {
      console.log(files)
      this.$toast.open({
        message: `${files.length} images uploaded`,
        type: 'is-success',
        position: 'is-top',
        queue: false,
        duration: 5000
      })
      this.isUploading = false
    },
    dropzoneSuccess(file, response) {
      this.successFileCount++
      // console.log(file)
      // this.images = []
      // this.$toast.open({
      //   message: `${this.queuedFileCount} images uploaded`,
      //   type: 'is-success',
      //   position: 'is-top',
      //   queue: false,
      //   duration: 5000
      // })
      // this.isUploading = false
    },
    dropzoneErrorMultiple(files, message, xhr) {
      this.$toast.open({
        message: `${message}: ${xhr.statusText}`,
        type: 'is-danger',
        position: 'is-top',
        queue: false,
        duration: 5000
      })
      this.isUploading = false
    },
    dropzoneError(files, message, xhr) {
      this.failedFileCount++
      const statusText = xhr ? xhr.statusText : ''
      this.$toast.open({
        message: `${message}: ${statusText}`,
        type: 'is-danger',
        position: 'is-top',
        queue: false,
        duration: 5000
      })
      this.isUploading = false
    },
    dropzoneSending(file, xhr, formData) {
      // console.log(file)
      // for (var value of formData.values()) {
      //   console.log(value)
      // }
    },
    dropzoneCompleteMultiple(files) {
      // console.log(files.count)
    },
    dropzoneQueueComplete(files, xhr, formData) {
      if (this.successFileCount > 0)
        this.$toast.open({
          message: `${this.successFileCount} images uploaded`,
          type: 'is-success',
          position: 'is-top',
          queue: false,
          duration: 5000
        })
      this.isUploading = false
      this.queuedFileCount = 0
      this.successFileCount = 0
      this.failedFileCount = 0
      this.getImageIds()
      this.clearUploadedFile()
    },
    dropzoneTotalUploadProgress(totaluploadprogress, totalBytes, totalBytesSent) {
      this.isUploading = totaluploadprogress < 100
      // console.log(totaluploadprogress)
    },
    dropzoneRemoveAllFiles() {
      if (this.isUploading || !this.validQuote) {
        return
      }

      this.$refs.quoteImageDropzone.removeAllFiles()
      this.isClearAllActive = false
    },
    isMobile() {
      return platform.os.family.toLowerCase() === 'android' || platform.os.family.toLowerCase() === 'ios'
    },
    async getImageCategories() {
      this.imageCategories = await MobileImageUploaderService.getQuoteImageCategories(this.companyId)
      var customerUploaded = this.imageCategories.find(item => item.name === 'Customer Uploaded')
      this.selectedCategoryId = customerUploaded.quoteImageCategoryId
      if (this.quoteId && this.selectedCategoryId) {
          this.getImageIds()
      }
    },
    clearUploadedFile() {
      this.$refs.quoteImageDropzone.removeAllFiles()
    },
    async getQuote() {
      if(this.quoteImageHyperlinkId){
        var quote = await MobileImageUploaderService.getQuoteByImageHyperlinkId(this.quoteImageHyperlinkId)
        this.quote = quote
        this.quoteId = quote.quoteId
        this.companyId = quote.companyId
        this.isDropzoneActive = this.validQuote

        if(quote.companyId)
          this.getImageCategories()
        if(quote.vehicleId)
          this.getVehicle(quote.vehicleId)
      }
      else{
        this.quoteId = Guid.empty()
        this.isDropzoneActive = false
      }
    },
    async getVehicle(vehicleId){
      this.vehicle = await MobileImageUploaderService.getQuoteVehicleById(this.companyId, vehicleId)
    },
    async checkImageHyperlink() {
      try {
        const result = await this.$auth.getImageHyperlink(this.quoteImageHyperlinkId)
        this.isValidImageHyperlink = result.isValid

        if (result.expiredDate) {
         const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
         const utcDate = DateTime.fromISO(result.expiredDate, { zone: 'utc' })
         this.zonedExpiredDate = utcDate.setZone(userTimeZone)
        }

        if(this.isValidImageHyperlink){
          this.getQuote()

          this.dropzoneOptions.capture = this.isMobile
          ? this.mobileImageSourceType.Gallery
          : this.mobileImageSourceType.Camera
          document.title = this.$route.meta.title
        }
      } catch (error) {
        console.log('Error verifying image hyperlink:', error)
        this.isValidImageHyperlink = false
      }
    },
    closePopUp() {
      this.isShowPopUp = false
    },
    onFileRemoved(file) {
      this.deleteFileFromServer(file)
    },
    deleteFileFromServer(file) {
      //TODO: call service to delete image
    },
    countDownTimeout() {
      this.isValidImageHyperlink = false
    },
    async getImageIds() {
      this.imagesWithInfo.splice(0, this.imagesWithInfo.length)
      const vm = this
      this.imageIds = await MobileImageUploaderService.getImageIdsWithCategory(this.quoteId, this.selectedCategoryId)
      const promises = this.imageIds.map(function(id, index) {
        return vm.getThumbnailWithInfo(id, index)
      })
      this.imagesWithInfo = await Promise.all(promises)
    },
    async getThumbnailWithInfo(id, index) {
      var thumbnail = await MobileImageUploaderService.getImageThumbnailWithInfo(id, this.size)
      return thumbnail
    },
    async checkLinkStillActive() {
      if (this.isValidImageHyperlink) {
         const result = await this.$auth.getImageHyperlink(this.quoteImageHyperlinkId)
         this.isValidImageHyperlink = result.isValid
         if (this.isValidImageHyperlink) {
            this.scheduleNextCheck()
         } else {
            await this.checkImageHyperlink()
         }
      }
    },
    scheduleNextCheck() {
      this.timeoutId = setTimeout(async () => {
         await this.checkLinkStillActive()
      }, 2000)
    },
    clearTimeout() {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId)
        this.timeoutId = null
      }
    }
  }
}
</script>

<style lang="scss">
@import '../../assets/style/mixins/inputs/placeholder';

// input.uppercase {
//   text-transform: uppercase;
//   @include reset-placeholder-text-transform;
// }
.table-transparent {
   background-color: transparent;
}
.table-transparent td {
  border: 0
}
table:not(:last-child){
  margin-bottom:0 !important
}
.is-divider {
  border-top: .1rem solid #cfcece;
  height: .1rem;
  margin: 0.5rem 0;
  text-align: center;
}
.is-flex-items-center {
  display: flex;
  align-items: center;
}
</style>
